import styled from "@emotion/styled";
import { Skeleton } from "@kaltura/mediaspace-shared-styled";
import React from "react";

const StyledEntrySkeleton = styled(Skeleton)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    borderRadius: theme.kaltura.shape.roundness2,
}));

export const MediaListSkeleton = () => {
    return (
        <>
            {[...Array(3)].map((_, index) => (
                <StyledEntrySkeleton key={index} variant="rectangular" height={138} />
            ))}
        </>
    );
};
